import { render, staticRenderFns } from "./ShopBrand.vue?vue&type=template&id=b281d0ec&scoped=true"
import script from "./ShopBrand.vue?vue&type=script&lang=js"
export * from "./ShopBrand.vue?vue&type=script&lang=js"
import style0 from "./ShopBrand.vue?vue&type=style&index=0&id=b281d0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b281d0ec",
  null
  
)

export default component.exports